// extracted by mini-css-extract-plugin
export var container = "_5x-0";
export var fallback = "_5x-5";
export var fallbackIcon = "_5x-6";
export var hidden = "_5x-2";
export var image = "_5x-3";
export var loaded = "_5x-4";
export var placeholder = "_5x-1";